import { OnInit } from '@angular/core';
import { ButtonViewComponent } from './button-renderer-crypto';

export class DetailRendererCrypto extends ButtonViewComponent implements OnInit {
  ngOnInit() {
    super.ngOnInit();
    this.renderValue =  null;
    this.renderIcon = 'nb-search'
  }
}



// WEBPACK FOOTER //
// ./src/app/pages-crypto/renderer-crypto/detail-renderer-crypto.ts